module.exports = __webpack_public_path__ + "static/img/liucheng.33dba9d9.png";